import { atom } from 'jotai';

export const uiStateAtomFiltersModalIsOpened = atom(false);
